import React, { useEffect, useState } from 'react';
import { AssuredWorkloadOutlined, CalendarMonthOutlined, HandshakeOutlined, PublicOutlined, SpeedOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { PROVIDER_SOURCE } from 'libs/uikit/src/constants/quote';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var WhyYouChooseJoveView = function WhyYouChooseJoveView(props) {
  var className = props.className,
      info = props.info,
      providerCode = props.providerCode;

  var _useState = useState([]),
      benefits = _useState[0],
      setBenefits = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    var _list, _info$organization;

    var list = [{
      icon: /*#__PURE__*/_jsx(CalendarMonthOutlined, {
        sx: {
          fontSize: 16,
          color: '#ffffff'
        }
      }),
      title: 'Monthly payments — no annual lock-in'
    }];

    if ([PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(providerCode)) {
      list.push({
        icon: /*#__PURE__*/_jsx(PublicOutlined, {
          sx: {
            fontSize: 16,
            color: '#ffffff'
          }
        }),
        title: 'Courier, Household Removal or Vehicle Transportation Insurance'
      });
    } else if ([PROVIDER_SOURCE().GREATEAMERICAN.value].includes(providerCode)) {
      list.push({
        icon: /*#__PURE__*/_jsx(PublicOutlined, {
          sx: {
            fontSize: 16,
            color: '#ffffff'
          }
        }),
        title: 'Choose from Courier, Household Goods to AutoHauler'
      });
    } else {
      list.push({
        icon: /*#__PURE__*/_jsx(PublicOutlined, {
          sx: {
            fontSize: 16,
            color: '#ffffff'
          }
        }),
        title: 'Worldwide coverage including US & Canada'
      });
    }

    (_list = list).push.apply(_list, [{
      icon: /*#__PURE__*/_jsx(AssuredWorkloadOutlined, {
        sx: {
          fontSize: 16,
          color: '#ffffff'
        }
      }),
      title: 'Backed by A rated insurer'
    }, {
      icon: /*#__PURE__*/_jsx(SpeedOutlined, {
        sx: {
          fontSize: 16,
          color: '#ffffff'
        }
      }),
      title: 'Get covered in 30 seconds.'
    }]);

    if (info !== null && info !== void 0 && (_info$organization = info.organization) !== null && _info$organization !== void 0 && _info$organization.name) {
      list.push({
        icon: /*#__PURE__*/_jsx(HandshakeOutlined, {
          sx: {
            fontSize: 16,
            color: '#ffffff'
          }
        }),
        title: "Automatic insurance validation with ".concat(info.organization.name)
      });
    }

    if ([PROVIDER_SOURCE().GREATEAMERICAN.value].includes(providerCode)) {
      list = updateMTCDisplayList();
    }

    setBenefits(list);
  }, [info, providerCode]);

  var updateMTCDisplayList = function updateMTCDisplayList() {
    var _info$organization2;

    var list = [{
      icon: /*#__PURE__*/_jsx(AssuredWorkloadOutlined, {
        sx: {
          fontSize: 16,
          color: '#ffffff'
        }
      }),
      title: 'Backed by Great American Insurance Group, A+ rated insurer'
    }, {
      icon: /*#__PURE__*/_jsx(PublicOutlined, {
        sx: {
          fontSize: 16,
          color: '#ffffff'
        }
      }),
      title: 'Cover State to State Courier or House Removal work'
    }];

    if (info !== null && info !== void 0 && (_info$organization2 = info.organization) !== null && _info$organization2 !== void 0 && _info$organization2.name) {
      list.push({
        icon: /*#__PURE__*/_jsx(HandshakeOutlined, {
          sx: {
            fontSize: 16,
            color: '#ffffff'
          }
        }),
        title: "Get the right insurance cover and validate through ".concat(info.organization.name, " platform instantly")
      });
    }

    list.push.apply(list, [{
      icon: /*#__PURE__*/_jsx(SpeedOutlined, {
        sx: {
          fontSize: 16,
          color: '#ffffff'
        }
      }),
      title: 'Full digital quote within 30 seconds'
    }, {
      icon: /*#__PURE__*/_jsx(CalendarMonthOutlined, {
        sx: {
          fontSize: 16,
          color: '#ffffff'
        }
      }),
      title: '9 instalment payments to spread your cost'
    }]);
    return list;
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col space-y-6', className),
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "h1",
      className: "self-start text-2xl font-black text-[#202020]",
      children: "Why switch to Jove?"
    }), /*#__PURE__*/_jsx(Box, {
      className: "flex flex-col space-y-4",
      children: benefits.map(function (item, index) {
        return /*#__PURE__*/_jsxs(Box, {
          className: "flex flex-row items-center space-x-2",
          children: [/*#__PURE__*/_jsx(Box, {
            className: "flex h-7 w-7 items-center justify-center rounded-full bg-[#0E35D1]",
            children: item.icon
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "subtitle1",
            className: "flex-1 font-medium text-[#202020]",
            children: item.title
          })]
        }, index);
      })
    })]
  });
};